import type { StyleRule } from '@archipro-design/aria';
import { captionClassName, pxArrayToRem, pxToRem } from '@archipro-design/aria';
import { MOBILE_FULL_WIDTH } from '~/modules/design-board/config';

export const FilterContentLayoutWrapper: StyleRule = () => ({
    height: '100%',
    width: pxToRem(MOBILE_FULL_WIDTH),
});

export const FilterContentLayoutContent: StyleRule = () => ({
    [`& > .${captionClassName}`]: {
        padding: pxArrayToRem([31, 20, 10, 0]),
    },
});
